import * as yup from 'yup';

export const FlexFieldPanelAssignmentSchema = yup.object({
  selectedPanel: yup
    .string()
    .required("Panel selection is required")
});
